import React from 'react';
import { css } from '@emotion/react';
import cookieHelper from '../../utils/cookieHelper';

const PlanningPageLoading = () => {
  const titleCss = css({
    height: '34px',
    background: '#dcdcdc',
    borderRadius: '3px',
  });
  const btnDefCss = css({
    height: '30px',
    width: '30px',
    backgroundColor: '#fff',
    borderRadius: '3px',
    boxShadow: '0 1px 5px 0 rgb(0 0 0 / 20%)',
  });

  const btnMediumWith = css([btnDefCss, { width: '50px' }]);
  const btnNormalWith = css([btnDefCss, { width: '75px' }]);
  const btnGreen = css([btnDefCss, { width: '36px' }]);
  const btnSmall = css([btnMediumWith, { height: '26px' }]);
  const btnSmallHeight = css([btnNormalWith, { height: '26px' }]);

  const renderHeader = () => (
    <div className="pageMainWrapper__header">
      <div className="pageMainWrapper__header-left --marginRight-25">
        <div
          className="backgroundLoading"
          css={titleCss}
        />
      </div>
      <div className="blank" />
      <div className="pageMainWrapper__header-controls">
        <div css={btnDefCss} />
        <div className="--marginLeft-10" css={btnDefCss} />
        <div className="--marginLeft-10" css={btnDefCss} />
        <div className="--marginLeft-20" css={btnNormalWith} />
        <div className="--marginLeft-20" css={btnGreen} />
      </div>
    </div>
  );

  const labelCss = css({
    height: '16px',
    width: '70%',
    backgroundColor: '#9a9a9a',
    borderRadius: '3px',
  });
  const inputCss = css({
    height: '28px',
    width: '100%',
    backgroundColor: '#fff',
    border: '1px solid #dcdcdc',
    borderRadius: '3px',
    marginTop: '8px',
    marginBottom: '20px',
  });

  const renderSelector = () => (
    <div>
      <div className="backgroundLoading" css={labelCss} />
      <div css={inputCss} />
    </div>
  );

  const wrapFieldCss = css({
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
  });
  const boxCss = css({
    height: '22px',
    width: '22px',
    backgroundColor: '#eaeaea',
    borderRadius: '3px',
  });

  const renderCheckbox = (index = '') => (
    <div key={index} css={wrapFieldCss}>
      <div css={boxCss} />
      <div className="--marginLeft-10" css={labelCss} />
    </div>
  );

  const renderCheckboxBlock = () => (
    <div className="--marginTop-20">
      <div className="backgroundLoading" css={labelCss} />
      {renderCheckbox()}
    </div>
  );

  const renderCheckList = () => (
    <div className="--marginTop-20">
      <div className="backgroundLoading" css={labelCss} />
      {[...Array(7).keys()].map((index) => renderCheckbox(index))}
    </div>
  );

  const renderFilterBar = () => (
    <div
      className="filterBar"
      css={{
        width: cookieHelper.get('filterBarWidth') ? +cookieHelper.get('filterBarWidth') : 'auto',
      }}
    >
      <div className="filterBar__wrap">
        <div className="filterBar__actions">
          <div css={btnSmallHeight} />
          <div
            className="--marginLeft-10"
            css={btnSmall}
          />
        </div>
        <div className="filterBar__container">
          <div className="filtersList --marginTop-10">
            {renderSelector()}
            {renderSelector()}

            {renderCheckboxBlock()}
            {renderCheckboxBlock()}

            {renderCheckList()}
          </div>
        </div>
      </div>
    </div>
  );

  const tableHeaderDay = css({
    height: '12px',
    width: '22px',
    backgroundColor: '#9a9a9a',
    borderRadius: '3px',
    '@media (min-width: 1px) and (max-width: 1440px)': {
      height: '8px',
      width: '18px',
    }
  });
  const tableHeaderDate = css({
    marginTop: '5px',
    height: '35px',
    width: '45px',
    backgroundColor: '#eaeaea',
    borderRadius: '3px',
    '@media (min-width: 1px) and (max-width: 1440px)': {
      height: '12px',
      width: '30px',
    }
  });

  return (
    <div className="pageMainWrapper">
      {renderHeader()}
      <div className="pageMainWrapper__container">
        <div className="pageMainWrapper__container--collapse">
          {renderFilterBar()}
          <div className="pageMainWrapper__container-main">
            <div className="planningCalendar">
              <div className="tableFlex">
                <div className="tableFlex__header">
                  {[...Array(7).keys()].map((index) => (
                    <div
                      key={index}
                      className="tableFlex__header-cell --dateHeader"
                    >
                      <div>
                        <div css={tableHeaderDay} />
                        <div className="--dateHeaderDay">
                          <div css={tableHeaderDate} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="tableFlex__body">
                  <div className="tableFlex__body-row --fixed" />
                  <div className="tableFlex__body-row --weekBG">
                    {[...Array(7).keys()].map((index) => (
                      <div
                        key={index}
                        className="tableFlex__body-cell"
                      >
                        <div className="shiftList shiftList--column" />
                      </div>
                    ))}
                  </div>
                  <div className="tableFlex__body-row --fixed" />
                  <div className="tableFlex__body-row --weekBG">
                    {[...Array(7).keys()].map((index) => (
                      <div
                        key={index}
                        className="tableFlex__body-cell"
                      >
                        <div className="shiftList shiftList--column" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanningPageLoading;
